import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';

import * as Quill from 'quill';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'text-editor',
    templateUrl: './text-editor.template.html',
    styleUrls: ['./text-editor.style.scss'],
    standalone: false
})
export class TextEditor implements OnInit, AfterViewInit {

  wordCount: number = 0;
  savedText: string = "";
  learnerText: string = "";
  quill:any;
  placeHolder: string = "";
  isEditorDirty: boolean = false;
  private setSavedInputCalled: boolean = false;

  public maxCharsAllowed;
  public quillContainerId = 'quill-container';
  @Input() textEditorDisable: boolean;
  @Input() contentType: 'pskill' | 'cup-collab-task' = 'pskill';
  @Input() activityName?: string; // Name of the activity, used for accessibility of the text editor
  // @ViewChild('userInput') userinput : ElementRef; // part of WYSIWYG EDITOR implementation
  @Output() editorDirty = new EventEmitter<boolean>();  //emit when user makes a change
  @Output() textSubmit = new EventEmitter<string>();  //emit when user clicks on post btn (For Collab Activities)

  constructor(private translateService: TranslateService) {
    this.translateService.get('TEACHER.ACTIVITYVIEW.TYPE_HERE').subscribe((placeholder)=>{
      this.placeHolder = placeholder;
    });
  }

  ngOnInit() {
    this.quillContainerId += ('-' + this.contentType);
    this.maxCharsAllowed = this.contentType === 'pskill' ? 5000 : 6000;
  }

  ngAfterViewInit() {
    this.quill = new Quill('#' + this.quillContainerId, {
      modules: {
        toolbar: this.contentType === 'pskill' ? '#toolbar-container': '',
        keyboard: {
          bindings: { tab: false }
        }
      },
      placeholder: this.placeHolder,
      theme: 'snow',
      formats: this.contentType === 'pskill' ? ['bold', 'italic', 'underline'] : [],
    });
    this.quill.root.role = 'textbox';
    this.quill.root.setAttribute('aria-multiline', 'true');

    if(this.activityName) {
      this.quill.root.setAttribute('aria-label', this.activityName + ' ' +  this.translateService.instant('TEACHER.ACTIVITYVIEW.ANSWER_LABEL'));
    }

    this.quill.on('text-change', (delta, oldDelta, source) => {
      this.savedText = this.quill.root.innerHTML;
      this.wordCounter(this.quill.getText());
    });

    if (this.textEditorDisable) {
      this.quill.enable(false);
    }
  }

  setSavedInput(savedInput: any) {
    this.setSavedInputCalled = true;
    if (this.textEditorDisable) {
      this.quill.root.innerHTML = "";
    } else {
      this.quill.root.innerHTML = savedInput ? savedInput : "";
    }
  }

  /**
   * @param value raw text entered by user in quill
   */
  wordCounter(value) {
    //on first change, make editor dirty and emit
    if(value && value.length == 1 && value[value.length-1] == "\n") { // quill always return '\n' even with empty data
      this.editorDirty.emit(false);
      this.isEditorDirty = false;
    } else {
      if (!this.setSavedInputCalled) {
        this.editorDirty.emit(true);
      } else {
        this.setSavedInputCalled = false;
      }
      this.isEditorDirty = true;
    }
    this.learnerText = value;
    if(value.length > this.maxCharsAllowed) {
      let length = value.length - this.maxCharsAllowed;
      this.quill.deleteText(this.maxCharsAllowed, length + 1);
    }
    if (this.contentType === 'pskill') {
      this.wordCount = value ? (value.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0;
    }
  }

  emitSubmit() {
    //NEMO-17826 | removing focus from post button after response submission 
    document.getElementById("post-collabTask-btn").classList.remove('focus-visible');
    this.textSubmit.emit(this.savedText);
    this.setSavedInput('');
  }

  checkEditing(event) {
        // Do not stop shortcut keys
        if(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
            return;
        }
        let studentAnswer = event.target.value;
        let enterCounts = this.getEnterCount(event.target.value);
        if ( studentAnswer.length - enterCounts/2 >= 5000) {
            // Do not stop backspace, delete, up, down, left, right keys.
            if (event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
                event.preventDefault();
            }
        }
    }
    getEnterCount(studentAnswer) {
        let enterCounts = 0;
        var endcount = 5000;
        for (var i=0; i<endcount; i++) {
            if(studentAnswer.charAt(i) === "\n" ) {
                endcount++;
                enterCounts++;
            }
        }
        return enterCounts;
    }


    // returns the current text  by user
    getCurrentInput() {
      return this.savedText;
    }
   /** 
  
   IMPLEMENTS WYSIWYG EDITOR

  private changes: MutationObserver;
  @ViewChild('userInput') userinput : ElementRef;
  private tools: Tool[] = [
    { cmd: 'bold', selected: false, icon: 'bold'},
    { cmd: 'italic', selected: false, icon: 'italic'},
    { cmd: 'underline', selected: false, icon: 'underline'},
    { cmd: 'heading', val: "H3", selected: false, icon: 'text-height'},
    { cmd: 'insertOrderedList', selected: false, icon: 'list-ol'},
    { cmd: 'insertUnorderedList', selected: false, icon: 'list-ul'},
  ];
 
  setTool(tool: Tool){
    tool.selected = !tool.selected;
    document.execCommand(tool.cmd, false, (tool.val || "")); 

    interface Tool{
      cmd: string,
      selected: boolean,
      icon: string,
      val?: string 
    }


      constructor() {
    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => this.wordCounter());
    })
  }

  ngAfterViewInit(){
    this.changes.observe(this.userinput.nativeElement, { characterData: true, subtree: true });
  } 

  onTextPaste(event: ClipboardEvent){
    event.preventDefault();
    let clearText = event.clipboardData.getData('text/plain');
    document.execCommand('inserttext', false, clearText);
  }

  wordCounter(){
    let trimmed = this.userinput.nativeElement.innerText;
    let newWordCount = trimmed ? (trimmed.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0;
    if(newWordCount != this.wordCount){
      this.wordCount = newWordCount
      this.wordsCounted.emit(this.wordCount);
    }
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }



  }*/

}

